(function () {
  angular
    .module("akitabox.ui.components.appHeader")
    .filter("headerSearch", AbxHeaderSearch);

  function AbxHeaderSearch() {
    return function (list, searchTerm) {
      if (list) {
        var regex = new RegExp(searchTerm, "i");

        return list.filter(function (building) {
          return (
            regex.test(building.name) ||
            regex.test(building.address) ||
            regex.test(building.postal_code) ||
            regex.test(building.city) ||
            regex.test(building.state)
          );
        });
      } else {
        return list;
      }
    };
  }
})();
